import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from 'react-router-dom';
import '../../stylesheets/ForgetPassword.css';
import '../../stylesheets/Margins.css';
import Cookies from "js-cookie";
import projectLogo from '../../project_logo.png'
import { AuthAPI } from "../../axios";

const SetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], "Passwords must match")
    .required("Confirm password is required"),
});

const SetPassword = () => {
  const navigate = useNavigate();

  const handleSubmit = (values) => {
    console.log('Form data', values);
    const _id = Cookies.get("userId")

    AuthAPI.resetPassword(JSON.stringify({...values, _id}))
      .then((res) => {
        if (res.code === 200) {
          navigate('/login');
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="forget-container">
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <img
          src={projectLogo}
          alt="Profile"
          style={{
            width: '150px',
            height: '150px',
            borderRadius: '50%',
            objectFit: 'cover',
          }}
        />
      </div>
      <div className="forget-header">
        <span className="forget-text">
          Set a new password
        </span>
      </div>
      <Formik
        initialValues={{ password: '', confirmPassword: '' }}
        validationSchema={SetPasswordSchema}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form className="forget-inputs">
            <span className="email-text"> Password </span>
            <div className="forget-input">
              <Field name="password" type="password" placeholder="Enter a new password" />
            </div>
            <ErrorMessage name="password" component="div" className="error" style={{ marginTop: '0px', marginLeft: '0px' }}/>
            <br />
            <span className="email-text"> Confirm Password </span>
            <div className="forget-input">
              <Field name="confirmPassword" type="password" placeholder="Confirm your new password" />
            </div>
            <ErrorMessage name="confirmPassword" component="div" className="error" style={{ marginTop: '0px', marginLeft: '0px' }}/>
            <div className="margin20">
              <button type="submit" className="forget-button"> Set Password </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SetPassword;
